import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";
import { API_BASE_URI } from "../ApiCall";
import { TaxPaymentActionTypes } from "./TaxPayment.type";

export function* fetchAllTaxPaymentSaga(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/tax-payment`, {
      params: action.payload,
    });
    yield put({
      type: TaxPaymentActionTypes.FETCH_ALL_TAX_PAYMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: TaxPaymentActionTypes.FETCH_ALL_TAX_PAYMENT_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneTaxPaymentSaga(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/tax-payment/${action?.payload?.id || action?.payload}`
    );
    yield put({
      type: TaxPaymentActionTypes.FETCH_ONE_TAX_PAYMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: TaxPaymentActionTypes.FETCH_ONE_TAX_PAYMENT_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllTaxPayment() {
  yield takeLatest(
    TaxPaymentActionTypes.FETCH_ALL_TAX_PAYMENT,
    fetchAllTaxPaymentSaga
  );
}

export function* watcherFetchOneTaxPayment() {
  yield takeLatest(
    TaxPaymentActionTypes.FETCH_ONE_TAX_PAYMENT,
    fetchOneTaxPaymentSaga
  );
}
